import { Stack, Typography } from '@mui/material';
import React from 'react';

import { InfoIcon } from '@/shared/assets/icons/info-icon';
import { TResourceDetailItem } from '@/shared/components/ui/resource-detail/item/resource-detail-item.types';
import { Tooltip } from '@/shared/components/ui/tooltip/tooltip';
import { TruncatedText } from '@/shared/components/ui/truncated-text/truncated-text';

export const ResourceDetailItem: React.FC<TResourceDetailItem> = ({
  value,
  label,
  colSpan = 1,
  tooltip,
}) => {
  const renderValue = () => {
    if (!value) {
      return '-';
    }

    if (typeof value === 'string' || typeof value === 'number') {
      return (
        <TruncatedText
          maxLength={24 * colSpan}
          text={String(value)}
          variant="p7"
          color="textPrimary"
        />
      );
    }
    return value;
  };

  return (
    <Stack gap="0.75rem" justifyContent="center">
      {label && (
        <Stack direction="row" alignItems="center" gap="0.5rem" flexWrap="wrap">
          {typeof label === 'string' ? (
            <Typography variant="p8" color="textSecondary">
              {label}
            </Typography>
          ) : (
            label
          )}
          {tooltip && (
            <Tooltip title={tooltip}>
              <InfoIcon size="1rem" color="textSecondary" />
            </Tooltip>
          )}
        </Stack>
      )}
      {renderValue()}
    </Stack>
  );
};
